const url = process.env.REACT_APP_API_URL + "/api/user_files";

const urlSecond = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL + "/api/files/upload-form";

export default {
  freeUpload: `${urlSecond}`,
  upload: `${url}/`,
};
